<div class="restrict-access-overlay" 
    [ngClass]="{'overlay-background': isDialog}">
  <div class="restrict-access-popup"
    [ngClass]="{'overlay-background': isDialog, 'default-dialog-styles': defaultDialogStyles, 'custom-dialog-styles': applyCustomDialogStyles}">
    <div class="inner-container">
      <div class="restrict-action-header">
        <div class="icon-container">
          <img class="restrict-icon" src="assets/images/access_restricted.svg" alt="Access Restricted"
            id="access-restricted-icon">
        </div>
  
        <div class="restrict-action-title" id="access-restrict-title">Access Restricted: {{restrictionTypeTitle}}</div>
      </div>
      <div class="restrict-access-content" id="restrict-access-content">
        <div class="content-inner">
          <div class="restrict-action-msg">
            <div *ngIf="componentName && restrictionType === 'tier_upgrade'" class="component-name">{{componentName}}</div>
            <div class="action-text inline">{{actionMsg1}}</div>
            <div class="action-text">{{actionMsg2}}</div>
          </div>
    
          <div class="contact-details" *ngIf="!isBillingAdmin">
            <span>Please contact site's Billing Admin:</span>
            <ul class="billing-admins-list">
              <li *ngFor="let admin of siteBillingAdmins; let i = index" [id]="'admin-' + i">
                {{ admin.personalInfo?.firstName }} {{ admin.personalInfo?.lastName }} ({{ admin.emailId }})  
              </li>
            </ul>
    
            <div class="icon-container">
              <a [href]="emailContent"><img src="assets/images/mail-icon.svg" class="mail-icon" alt="Mail" id="mail-icon"></a>
            </div>
          </div>
    
          <div class="action-btn-container" *ngIf="isBillingAdmin">
            <button class="action-btn" (click)="onButtonClick()" id="action-btn-restrict">{{ actionBtnlabel }}</button>
          </div>
    
          <div class="support-link-container" *ngIf="restrictionType === 'tier_upgrade'">Know about {{ componentName }}? <a [href]="supportUrl" target="_blank"
              id="support-redirect" class="support-link">Visit {{parnerName}} Support</a>
          </div>
        </div>
      </div>
  
    </div>
  </div>
</div>